import React from "react";
import { Link } from "react-router-dom";

/** The logo + "a Jewish Music Lab experiment" line worn by the studio pages. */
export default function LabStamp({ testId = "lab-stamp" }) {
  return (
    <Link
      to="/"
      className="inline-flex items-center gap-2.5 group"
      data-testid={testId}
    >
      <img
        src="/lab-logo.png"
        alt=""
        aria-hidden="true"
        style={{ width: 26, height: 26, objectFit: "contain" }}
      />
      <span
        className="text-[11px] uppercase transition-colors group-hover:text-[#E86F4A]"
        style={{ color: "#8C8198", fontFamily: "'Courier Prime', monospace", letterSpacing: "0.2em" }}
      >
        a Jewish Music Lab experiment
      </span>
    </Link>
  );
}
